import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, ElementRef, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { SfProductLinkDirective } from '@scalefast/components';
import { Product } from '@scalefast/core';
import { StaticFileHash } from '@scalefast/ecommerce-core';
import { asapScheduler } from 'rxjs';
import { MISSING_PRODUCT_IMAGE_URL } from '../../../../../app.tokens';
import { GenericEventService } from '../../../../../shared/services';

import { HighlighterPipe } from '../../../../pipes/highlight-text.pipe';
import { TranslateProductFieldPipe } from '../../../../pipes/translate-product-field.pipe';

@Component({
  selector: 'app-search-bar-template',
  templateUrl: './search-bar-template.component.html',
  styleUrls: ['./search-bar-template.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgClass,
    RouterLink,
    SfProductLinkDirective,
    NgOptimizedImage,
    HighlighterPipe,
    TranslateProductFieldPipe,
    StaticFileHash,
  ],
})
export class AppSearchBarTemplateComponent {
  @Input() searchResults: Array<Product> = [];
  @Input() isActiveSearch = true;
  @Input() isMobile = true;

  @Output() searchFormChange = new EventEmitter<string>();
  @Output() resetFilters = new EventEmitter<void>();
  @Output() goToSearchResultsPage = new EventEmitter<string>();
  @Output() triggerSearchBarMobile = new EventEmitter<void>();

  searchForm: FormGroup = new FormGroup({
    search: new FormControl(),
  });

  @ViewChild('searchBar', { static: true }) searchBar!: ElementRef<HTMLInputElement>;

  constructor(
    private genericEventService: GenericEventService,
    @Inject(MISSING_PRODUCT_IMAGE_URL) public missingProductImageUrl: string,
  ) {}

  onFocusOut(): void {
    asapScheduler.schedule(() => {
      this.searchForm.reset();
      this.emitResetFilters();
    }, 1000);
  }

  emitSearchFormChanges(): void {
    this.searchFormChange.emit(this.searchForm.value);
  }

  emitResetFilters(): void {
    this.resetFilters.emit();
  }

  emitGoToSearchResultsPage(searchCriteria: string): void {
    // If the search results page it's empty we don't do anything
    if (!searchCriteria) {
      return;
    }
    this.goToSearchResultsPage.emit(searchCriteria);
  }

  emitTriggerSearchBarMobile(): void {
    this.triggerSearchBarMobile.emit();
  }

  clickSearchProduct(): void {
    this.genericEventService.emitSearchProductClick();
  }

  focusInput() {
    // We must wait till the input is visible
    setTimeout(() => {
      this.searchBar.nativeElement.focus();
    }, 100);
  }

  cleanInput() {
    this.searchForm.reset();
  }
}
